export { default } from './Page.vue'
